module.exports = __webpack_public_path__ + "img/medalha-acesso-a-justica.06a6bc47.jpeg";